export const SET_CURRENT_USER             = "SET_CURRENT_USER";

export const GET_STAKING_USER             = "GET_STAKING_USER";